import { Alert } from '@mui/material';
import { useRouteError } from 'react-router-dom';

const RouteErrorBoundary = () => {
  const error = useRouteError();

  return (
    <Alert sx={{ maxWidth: '1200px', margin: '24px auto' }} severity="error">
      Route Loading Error:{' '}
      {error instanceof Error ? error.message : String(error)}
    </Alert>
  );
};

export default RouteErrorBoundary;
